import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { ButtonToolbar } from '@appfolio/react-gears';
import classnames from 'classnames';
import { isMobileView } from "../helpers/layoutUtils.js";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "19de7qh",
  styles: "min-height:30px;"
} : {
  name: "19de7qh",
  styles: "min-height:30px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Header = function Header(_ref) {
  var pageTitle = _ref.pageTitle,
      _ref$headerContent = _ref.headerContent,
      HeaderContent = _ref$headerContent === void 0 ? function () {
    return null;
  } : _ref$headerContent,
      _ref$subheaderContent = _ref.subheaderContent,
      SubheaderContent = _ref$subheaderContent === void 0 ? function () {
    return null;
  } : _ref$subheaderContent,
      _ref$subheaderButtons = _ref.subheaderButtons,
      SubheaderButtons = _ref$subheaderButtons === void 0 ? function () {
    return null;
  } : _ref$subheaderButtons;
  return jsx("header", {
    className: isMobileView() ? '' : 'mb-4'
  }, jsx("div", {
    className: classnames('d-flex', 'text-white', 'bg-dark', 'px-3', 'py-2', 'm-0', 'align-items-center', 'justify-content-between')
  }, jsx("h1", null, pageTitle), jsx(HeaderContent, null)), jsx("div", {
    className: classnames('d-flex', 'border-bottom', 'py-2', 'text-dark', 'bg-white', 'px-3', 'align-items-center', 'justify-content-between'),
    css: _ref2
  }, jsx("span", null, jsx(SubheaderContent, null)), jsx("div", null, jsx(ButtonToolbar, {
    className: "align-items-center mt-0"
  }, jsx(SubheaderButtons, null)))));
};

Header.displayName = "Header";
Header.propTypes = {
  pageTitle: _pt.string.isRequired,
  children: _pt.node
};
export default Header;